module.exports = __webpack_public_path__ + "img/dingzhi.79ccb914.png";